export default __webpack_public_path__ + "static/media/component_servo_motor_360.59e4b74b.png";